const PRELOADER_VIEW_DELAY_MS = 1500;
const PRELOADER_ID = 'initial-preloader';

export { PRELOADER_VIEW_DELAY_MS, PRELOADER_ID };
